<template>
	<div class="box">
		<!-- 页面_Pc -->
		<div class="book" @wheel.prevent="wheel" v-if="book">
			<!-- 01-封面 --> 
			<div class="cover">
				<img src="../../assets/img/1-2.png" class="title">
				<img src="../../assets/img/1-3.png" class="bom">
				<div class="tips">
					鼠标滚动上下翻页 <span class="iconfont">&#xe6bd;</span>
				</div>
				<div class="info">
					主办单位：中共河南省委宣传部&nbsp;&nbsp;&nbsp;河南省文化和旅游厅&nbsp;&nbsp;&nbsp; 河南省文物局 <br>承办单位：河南博物院
				</div>
			</div>
			<!-- 02-前言 -->
			<div class="foreword">
				<img v-lazy="pageImg.foreword_1" class="top">
				<img v-lazy="pageImg.foreword_2" class="bom">
				<div class="content">
					<div class="font">
						<li>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上世纪六十年代，安阳林县十万开山者，绝壁穿石，苦干十年，孕育形成伟大的“自力更生、艰苦创业、团结协作、无私奉献”红旗渠精神，同延安精神一脉相承，成为中国共产党人精神谱系中的闪亮坐标。
						</li>
						<li>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2022年10月28日，习近平总书记到林州红旗渠视察，面对这一伟大工程语重心长地讲到：“红旗渠就是纪念碑，记载了林县人不认命、不服输、敢于战天斗地的英雄气概。要用红旗渠精神教育人民特别是广大青少年，社会主义是拼出来、干出来、拿命换来的，不仅过去如此，新时代也是如此。”
						</li>
						<li>
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一渠绕群山，精神动天下。河南博物院遴选馆藏历史资料，结合相关视频，推出 “人工天河——红旗渠精神图片展”，从“艰苦奋斗、伟大工程、梦想成真、精神永在”四个方面，通过跟踪拍摄的影像资料，回顾筑渠艰苦历程，感悟、践行和传承红旗渠精神，不辜负时代赋予的使命，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴贡献力量。
						</li>
					</div>
					<a href="https://weibo.com/tv/show/1034:4643221087911999">
					<div class="videoBtn">
						三维地图视频
						<img v-lazy="pageImg.foreword_3" class="btnImg">
					</div>
					</a>
					<div class="title">前言</div>
				</div>
			</div>
			<!-- 03-引文 -->
			<div class="quotation">
				<div class="content">
					<div class="topLeft">
						<div class="title">劈山引水</div>
					</div>
					<div class="rightImg">
						<img v-lazy="pageImg.quotation_2">
					</div>
					<div class="font">
						林州人民经过10年的艰苦奋斗，兴建了长达1500多公里的红旗渠，共削平1250多个山头，这些岩石仍残留着炸药爆炸的痕迹。
						<div class="bor"></div>
					</div>
				</div>
			</div>
			<!-- 04-导航 -->
			<div class="nav">
				<div class="title">章节</div>
				<div class="list">
					<img v-lazy="pageImg.section_2" class="figure">
					<div class="content">
						<div class="li" @click="goTo(5)">
							<div class="top">第一章</div>
							<div class="bom">艰苦奋斗</div>
							<div class="lin"></div>
						</div>
						<div class="li" @click="goTo(33)">
							<div class="top">第二章</div>
							<div class="bom">伟大工程</div>
							<div class="lin"></div>
						</div>
						<div class="li" @click="goTo(47)">
							<div class="top">第三章</div>
							<div class="bom">梦想成真</div>
							<div class="lin"></div>
						</div>
						<div class="li" @click="goTo(65)">
							<div class="top">第四章</div>
							<div class="bom">精神永在</div>
							<div class="lin"></div>
						</div>
					</div>
				</div>
				<img v-lazy="pageImg.section_1" class="mountain">
			</div>
			<!-- 页面 -->
			<div v-for="(item,index) in list" :key="index" class="pageBox" v-lazy-container="{selector:'img'}">
				<!-- 章节 -->
				<div v-if="item.section == true" class="sectionContent">
					<img :data-src="pageImg.sectionContent" class="back" @click="navBox = !navBox">
					<div class="title">{{item.title}}  </div>
					<div class="rightRed"></div>
					<a :href="item.videoUrl">
					<div class="videoTitle">
						<img :data-src="pageImg.foreword_3" class="btnImg">
						{{item.videoName}}
					</div>
					</a>
					<div class="listBox">
						<li class="list" v-for="(item,index) in item.list" :key="index" @click="goTo(item.goPage)">
							<div class="top">{{index >= 9 ? (index+1) :'0'+(index+1)}}</div>
							<div class="bom">{{item.name}}</div>
						</li>
					</div>
				</div>
				<!-- 详情-视频 -->
				<div v-else-if="item.videoState" class="videoContent">
					<img :data-src="pageImg.sectionContent" class="back" @click="navBox = !navBox">
					<img :data-src="pageImg.PageContent" class="bom">
					<div class="rightRed"> <span>{{item.page}} / 71</span> </div>
					<div class="num">          				  {{item.num}}  </div>
					<div class="pageTitle">    				  {{item.title}}</div>
					<a :href="item.videoUrl">
					<div class="videoBox">
						<img :data-src="item.imgUrl">
						<div class="videoTitle">{{item.videoName}}</div>
						<p class="iconfont">&#xea82;</p>
					</div>
					</a>
				</div>
				<!-- 详情 -->
				<div v-else class="PageContent">
					<img :data-src="pageImg.sectionContent" class="back" @click="navBox = !navBox">
					<img :data-src="pageImg.PageContent" class="bom">
					<div class="rightRed"> <span>{{item.page}} / 71</span> </div>
					<div class="num">          				  {{item.num}}  </div>
					<div class="pageTitle">    				  {{item.title}}</div>
					<div class="content" v-if="item.content"> {{item.content}}</div>
					<div class="imgBox">
						<div v-if="item.img_1">
							<img :data-src="item.img_1">
							<p class="title"> {{item.img_1Title}} </p>
						</div>
						<div v-if="item.img_2">
							<img :data-src="item.img_2">
							<p class="title"> {{item.img_2Title}} </p>
						</div>
						<div v-if="item.img_3">
							<img :data-src="item.img_3">
							<p class="title"> {{item.img_3Title}} </p>
						</div>
					</div>
					<div class="word"> {{item.word}}</div>
				</div>
			</div>
		</div>
		<!-- 导航 -->
		<div class="navBox" v-show="navBox" @click="navBox = !navBox">
			<div class="list">
				<div class="btn iconfont" @click.stop="navBox = !navBox"> &#xeca0; </div>
				<div class="title">目录</div>
				<ul>
					<li v-for="(item,index) in navData" :key="index" @click="goTo(item.goPage)">
						<div :class="item.section == true ? 'section':'left' ">{{item.name}}</div>
						<div class="right">{{item.page}}</div>
					</li>
				</ul>
			</div>
		</div>
		<!-- 提示 -->
		<div class="resizeTips" v-show="!book">
			 <div class="iconfont">&#xe636;</div>
			 正在为您准备页面
		</div>
	</div>
</template>

<script>
	// jquery
	import $ from 'jquery'
	// 翻页特效
	import turn from '../../utils/turn'
	// 页面样式
	import './Page.scss'
	// 页面数据
	import {pageData,navData} from './data.js'

	export default {
		data () {
			return {
				// 滑动组件
				Turn : null,
				// 鼠标滚动标志
				flag : true,
				// 页面图片
				pageImg : {
					foreword_1     : require('../../assets/img/2-1.png'),
					foreword_2     : require('../../assets/img/2-2.png'),
					foreword_3     : require('../../assets/img/2-3.png'),
					quotation_2    : require('../../assets/img/3-2.jpg'),
					section_1      : require('../../assets/img/4-1.png'),
					section_2      : require('../../assets/img/4-2.png'),
					sectionContent : require('../../assets/img/5-1.png'),
					PageContent    : require('../../assets/img/5-2.png')
				},
				// 详情数据
				list   : null,
				// 导航数据
				navData : null,
				// 导航
				navBox : false,
				// 定时器记录
				reloadTime : null,
				// 整个盒子
				book : true
			}
		},
		watch:{
			
		},
		methods:{
			// 跳转指定索引页
			goTo(num){
				$(".book").turn("page", num);
				// 存入当前索引
				sessionStorage.setItem('itemNum',this.getIndex())
			},
			// 获取索引
			getIndex(){
				return $(".book").turn('page')
			},
			// 上一页
			pagePrev(){
				this.Turn.turn("previous");
				// 存入当前索引
				sessionStorage.setItem('itemNum',this.getIndex())
				// 获取索引
				// console.log('Index:' + this.getIndex());
			},
			// 下一页
			pageNext(){
				this.Turn.turn("next");
				// 存入当前索引
				sessionStorage.setItem('itemNum',this.getIndex())
				// 获取索引
				// console.log('Index:' + this.getIndex());
			},
			// 键盘监听
			KeyDown(event) {
				if (this.navBox == false) {
					const e = event || window.event || arguments.callee.caller.arguments[0];
					let key = e.keyCode;
					//左
					if (key == 37) {
						// this.Turn.turn("previous");
					} 
					//上
					else if(key == 38) {
						this.pagePrev()
					} 
					//右
					else if(key == 39) {	
						// this.Turn.turn("next");
					}
					//下 
					else if(key == 40) {	
						this.pageNext()
					}
				}
			},
			// 滚动
			wheel(e){
				if (this.flag == true) {
					if (e.deltaY < 0) {
						this.pagePrev()
					} else {
						this.pageNext()
					}
					// 鼠标滚动防止多次滚动
					this.flag = false
					setTimeout(() => {
						this.flag = true
					}, 300);
				}
			},
			// 翻页特效配置
			turnInit(){
				this.Turn = $('.book').turn({
					acceleration: true,      //启用硬件加速,移动端有效
					gradients   : true, 	 // 渐变
					duration    : 800,       // 翻页时间
					width		: '100%', 	 // Width
					height		: '100%', 	 // Height
					display     : 'single',  // 单页 single 双页 double
					elevation   : 1000,      // 翻起的高度
				})
				// 加载完成后前往指定索引页
				setTimeout(() => {
					this.goTo(sessionStorage.getItem('itemNum'))
				}, 50);
			}
		},
		mounted() {
			// 赋值数据
			this.list    = pageData
			this.navData = navData

			// 调用翻页特效
			this.$nextTick(() => {
				this.turnInit()
			})

			// 键盘监听
			window.addEventListener("keydown", this.KeyDown);

			// 监听窗口变化重新加载页面 修复js只加载一次问题
			window.addEventListener('resize',()=>{
				this.book = false
				if (this.reloadTime){
					clearTimeout(this.reloadTime)
				}
				this.reloadTime = setTimeout(() => {
					this.book = true
					this.$nextTick(() => {
						this.turnInit()
					})
				}, 500);
			})
			
			// 监听窗口变化重新加载页面 修复js只加载一次问题
			// 如果是微信端
			// if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
				// window.addEventListener('resize',()=>{
				// 	this.book = false
				// 	if (this.reloadTime){
				// 		clearTimeout(this.reloadTime)
				// 	}
				// 	this.reloadTime = setTimeout(() => {
				// 		// window.location.reload();
				// 		// alert('刷新')
				// 		this.book = true
				// 		this.$nextTick(() => {
				// 			this.turnInit()
				// 		})
				// 	}, 500);
				// })
			// }
			// else{
			// 	window.addEventListener('resize',()=>{
			// 		if (this.reloadTime){
			// 			clearTimeout(this.reloadTime)
			// 		}
			// 		this.reloadTime = setTimeout(() => {
			// 			location.reload();
			// 		}, 500);
			// 	})
			// }

			
		}
	}
</script>